import BaseIconSvg from '@/components/bases/BaseIconSvg';
import React from 'react';
import _ from 'lodash';
import emrTypeHelper from '@/helper/emrType';
import dayjs from 'dayjs';
import constants from '@/constants';
import useGlobalMobileConfigs from '@/stores/globalConfigsMobile';

interface Props {
  user?: IUser;
  healthsIndex?: any;
  bodyIndex?: any;
  onDetail?: () => void;
  from?: undefined | 'detail';
  navigate: (path: string, options?: Record<string, any>) => void;
}

const PHRMobileIndex = ({ user, from, healthsIndex, bodyIndex, onDetail, navigate }: Props) => {
  const emrTypes = useGlobalMobileConfigs((s) => s.emrTypes);
  const { btnUpdate } = bodyIndex || {};
  return (
    <>
      <div className="flex flex-row w-[100vw] items-center justify-between bg-transparent px-6 mb-4">
        <div className="flex flex-grow text-white flex-col items-start">
          <span className="headline-small font-normal">{bodyIndex?.label ?? 'Chỉ số cơ thể'}</span>
        </div>
        {from === 'detail' ? (
          btnUpdate?.isShow ? (
            <button
              onClick={() =>
                navigate(`/phr-mobile/logs/${user?._id}`, {
                  state: { user, uid: user?._id, emrType: btnUpdate?.emrTypeOpen, title: btnUpdate?.name },
                })
              }
              className="bg-gray-2 text-violet-14 items-center rounded-full h-9 px-8"
            >
              <span className="cms-h5 opacity-65">{btnUpdate?.label ?? 'Cập nhật'}</span>
            </button>
          ) : (
            <></>
          )
        ) : (
          <button onClick={onDetail} className="bg-transparent flex text-white items-center pr-0">
            <span className="label-small mr-1">Tất cả</span>
            <BaseIconSvg src="/icons/Small/Angle Right - icon.svg" className="wh-[8px]" />
          </button>
        )}
      </div>
      {bodyIndex && healthsIndex ? (
        <div className="overflow-auto hide-scroll-bar flex flex-row w-[100vw] bg-transparent pl-6 pb-2 pr-2">
          {bodyIndex.index.map((config: any | Index, key: number) => {
            const data: any = {};
            const componentData = healthsIndex[config.emrTypeGetData];
            const emrConfig = emrTypes?.[config.emrTypeOpen];
            Object.keys(config.routeValue || {})?.forEach((k) => {
              const route: string = config.routeValue?.[k]?.value || config.routeValue?.[k];
              const routeConfig = config.routeValue?.[k]?.config;
              data[k] = _.get(componentData, route);
              if (routeConfig) {
                const [emrTypeCode, fieldKey] = routeConfig.split('.');
                const emrType = emrTypes?.[emrTypeCode];
                const fieldConfig: IFieldConfig = emrType?.format.fields.find(
                  (f) => f.key === fieldKey,
                ) as IFieldConfig;
                const valueOption = emrTypeHelper.getOption(fieldConfig, data[k]);
                if (valueOption) {
                  data[k] = `<b style="color: ${valueOption.color}">
                        ${valueOption.label}
                      </b>`;
                } else if (fieldConfig?.inputType === 'date') {
                  data[k] = data[k]
                    ? dayjs(data[k]).format(fieldConfig.extra.format || constants.DATE_FORMAT)
                    : data[k];
                }
              }
            });

            const show = config?.format?.replace(/\{([\w.]+)\}/g, (match: any, key: string | number) => {
              return typeof data?.[key] !== 'undefined' ? data?.[key] : '--';
            });
            const classIcon = config?.iconColor ? ` text-[${config.iconColor}]` : ``;
            if (!data) return <></>;
            return (
              <button
                onClick={() => {
                  navigate(`/phr-mobile/records-by-type/${user?._id}`, {
                    state: {
                      emrTypeCode: emrConfig?.code,
                      emrDate: componentData?.date,
                      uid: user?._id,
                      title: emrConfig?.name,
                    },
                  });
                }}
                key={key.toString()}
                className="bg-[#35C0C5] text-white items-start justify-start mr-4 rounded-lg p-3 min-w-24 flex-none"
              >
                <span className="cms-body1 mr-1 flex flex-1">{config?.label}</span>
                <div className="flex flex-row items-center cms-h3">
                  <BaseIconSvg src={config?.icon} className={`wh-[16px] mr-1 ${classIcon}`} />
                  {show ? <div dangerouslySetInnerHTML={{ __html: show }}></div> : <></>}
                </div>
              </button>
            );
          })}
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default PHRMobileIndex;
